/**
 * `prefers-reduced-motion` is honoured in `tokens.css` — every transition
 * duration collapses to zero there, so no component has to remember it.
 *
 * This module is for the one thing CSS cannot do: the board's exit phase is a
 * timer in the store, and holding an element for 180 ms of animation that is
 * not going to play is 180 ms of a card the visitor asked to remove still
 * sitting on screen.
 */

export const EXIT_MS = 180;

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function exitDuration(): number {
  return prefersReducedMotion() ? 0 : EXIT_MS;
}
